import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useCookieConsent } from "../hooks/useCookieConsent";
import "./CookieBanner.css";

export default function CookieBanner() {
  const { t } = useTranslation("cookies");
  const { consent, hasConsented, acceptAll, rejectOptional, setConsent } =
    useCookieConsent();
  const [analytics, setAnalytics] = useState(consent.analytics);
  const [marketing, setMarketing] = useState(consent.marketing);

  if (hasConsented) return null;

  const handleSave = () => setConsent({ analytics, marketing });

  return (
    <div
      className="cookie-banner"
      role="dialog"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-body"
      data-testid="cookie-banner"
    >
      <div className="cookie-banner__inner">
        <div>
          <h2 id="cookie-banner-title" className="cookie-banner__title">
            {t("title")}
          </h2>
          <p id="cookie-banner-body" className="cookie-banner__body">
            {t("body")}{" "}
            <Link to="/legal/cookies">{t("moreLink")}</Link>
          </p>
        </div>

        <ul className="cookie-banner__toggles">
          <li className="cookie-banner__toggle">
            <label>
              <input
                type="checkbox"
                checked
                disabled
                aria-label={t("necessary.label")}
              />
              <span className="cookie-banner__toggle-text">
                <strong>{t("necessary.label")}</strong>
                <span>{t("necessary.help")}</span>
              </span>
            </label>
          </li>
          <li className="cookie-banner__toggle">
            <label>
              <input
                type="checkbox"
                checked={analytics}
                onChange={(e) => setAnalytics(e.target.checked)}
                aria-label={t("analytics.label")}
              />
              <span className="cookie-banner__toggle-text">
                <strong>{t("analytics.label")}</strong>
                <span>{t("analytics.help")}</span>
              </span>
            </label>
          </li>
          <li className="cookie-banner__toggle">
            <label>
              <input
                type="checkbox"
                checked={marketing}
                onChange={(e) => setMarketing(e.target.checked)}
                aria-label={t("marketing.label")}
              />
              <span className="cookie-banner__toggle-text">
                <strong>{t("marketing.label")}</strong>
                <span>{t("marketing.help")}</span>
              </span>
            </label>
          </li>
        </ul>

        <div className="cookie-banner__actions">
          <button
            type="button"
            className="btn btn-glass"
            onClick={rejectOptional}
          >
            {t("rejectOptional")}
          </button>
          <button
            type="button"
            className="btn btn-glass"
            onClick={handleSave}
          >
            {t("savePreferences")}
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={acceptAll}
          >
            {t("acceptAll")}
          </button>
        </div>
      </div>
    </div>
  );
}
